import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import projcetCost from '@/views/ViewsComponents/project/ProjectCost.vue'
import projcetTime from '@/views/ViewsComponents/project/ProjcetTime.vue'
import projcetAllocation from '@/views/ViewsComponents/project/ProjcetAllocation.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "项目成本" }, {
          default: _withCtx(() => [
            _createVNode(projcetCost)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "项目工时",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(projcetTime)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "成本分摊",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(projcetAllocation, null, null, 512), [
              [_directive_permission, void 0, "project_allocation"]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})